<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-card class="dt-container mt-2">
                    <v-data-table
                        :mobile="isMobileOrTablet()"
                        :headers="headers"
                        :items="data"
                        :search="search"
                        :loading="loading"
                        :items-per-page="15"
                        :items-per-page-options="[15, 30, 50, 100, -1]"
                    >
                        <template v-slot:loading>
                            <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                        </template>

                        <template v-slot:item.outcomes_count="{ item }">
                            <v-chip :color="item.outcomes_count > 0 ? 'blue' : 'grey'" size="small" variant="elevated">
                                {{ item.outcomes_count }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.action`]="{ item }">
                            <div class="d-flex justify-end ga-2">
                                <v-btn
                                    @click="showEditOutcomes(item)"
                                    size="small"
                                    variant="outlined"
                                    color="orange"
                                    elevation="3"
                                >
                                    Edit Outcomes
                                </v-btn>
                            </div>
                        </template>

                        <template v-slot:no-data>
                            <div class="d-flex justify-center pa-8">
                                <div class="text-center text-grey">
                                    <v-icon size="48" class="mb-2">mdi-clipboard-text-outline</v-icon>
                                    <div class="text-body-2">No faculty loads found for the selected semester.</div>
                                </div>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

    <FacultyCourseOutcomesDialog ref="FacultyCourseOutcomesDialog" />
</template>

<script>
import { defineComponent } from 'vue'
import FacultyCourseOutcomesDialog from '../Dialogs/FacultyCourseOutcomesDialog.vue'

export default defineComponent({
    components: {
        FacultyCourseOutcomesDialog,
    },
    data() {
        return {
            search: null,
            loading: false,
            data: [],
            headers: [
                { title: 'Course Code', align: 'start', sortable: true, key: 'code' },
                { title: 'Course Title', align: 'start', sortable: true, key: 'title' },
                { title: 'Section', align: 'start', sortable: true, key: 'section_code' },
                { title: 'Outcomes', align: 'center', sortable: true, key: 'outcomes_count' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],
        }
    },
    methods: {
        async init() {
            this.loading = true

            const res = await this.axiosCall(
                '/course-outcomes-scores/faculty-unique/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
                'get',
                null,
                true,
            )

            if (res && res.status === 200) {
                this.data = res.data
            }

            this.loading = false
        },
        showEditOutcomes(item) {
            this.$refs.FacultyCourseOutcomesDialog.init(item)
        },
    },
    mounted() {
        this.init()
    },
})
</script>

<style scoped>
</style>
